import { expVal } from '@atlaskit/platform-feature-experiments/exp-val';
import { UNSAFE_expValNoExposure } from '@atlaskit/platform-feature-experiments/unsafe-exp-val-no-exposure';

import { PrimaryProductKeys } from '../../constants/primary-product-keys';

// Only the Jira Quick Find query path opts into exposure; render and detail reads do not.
export const serveQfJiraUnhydratedResults = (
	primaryProduct?: string,
	{ fireExperimentExposure = false }: { fireExperimentExposure?: boolean } = {},
): boolean => {
	if (primaryProduct !== PrimaryProductKeys.Jira) {
		return false;
	}
	return fireExperimentExposure
		? expVal<boolean>('rovo_qf_jira_unhydrated_results', 'isEnabled', false)
		: UNSAFE_expValNoExposure<boolean>('rovo_qf_jira_unhydrated_results', 'isEnabled', false);
};
